<template>
  <div class="page-col">
    <div class="page-main">
      <!-- Header Premium -->
      <div class="list-header-premium d-flex flex-column flex-md-row align-items-center justify-content-between gap-3 p-0 mb-3" :class="{'bg-dark border-secondary': false}">
        <div class="d-flex align-items-center p-3 flex-shrink-0">
          <div class="header-icon-wrapper mr-3 ml-2" style="background: linear-gradient(135deg, #f6d365 0%, #fda085 100%);">
            <i class="fa fa-tags text-white"></i>
          </div>
          <div class="header-text-container">
            <h4 class="mb-0 font-weight-bold" :class="'text-dark'">Movimento da Etiqueta</h4>
            <p class="text-muted mb-0 small">Histórico de movimentação de estoque</p>
          </div>
        </div>

        <div class="d-flex align-items-center flex-wrap gap-2 p-3 w-100 w-md-auto justify-content-end">
            
            <!-- Responsive Search Pill -->
            <div class="search-pill-responsive d-flex align-items-center bg-light rounded-pill p-1 shadow-xs border mr-2">
                <div class="d-flex align-items-center px-2 mr-2 d-none d-sm-flex">
                    <b-form-radio-group
                      v-model="tipoPesquisa"
                      :options="opcoesPesquisa"
                      button-variant="outline-primary"
                      size="sm"
                      name="radio-btn-outline"
                      buttons
                    ></b-form-radio-group>
                </div>
                <!-- Mobile Select for Type -->
                <div class="d-sm-none px-2 mr-2">
                    <b-form-select v-model="tipoPesquisa" :options="opcoesPesquisa" size="sm" class="border-0 bg-transparent"></b-form-select>
                </div>
                
                <div class="d-flex align-items-center px-2 border-left mr-2">
                   <b-form-input 
                      ref="searchInput"
                      v-model="codigoPesquisa" 
                      placeholder="Digite o código..." 
                      style="width: 200px; border: none; background: transparent;"
                      @keyup.enter="pesquisar()"
                      @keydown.enter="pesquisar()"
                      class="input-search-responsive"
                   ></b-form-input>
                </div>
                <b-button variant="primary" pill class="px-4 font-weight-bold shadow-sm text-white btn-filtrar-responsive" :disabled="loading" @click="pesquisar()">
                    <i class="fa fa-search mr-1"></i> <span class="d-none d-sm-inline">PESQUISAR</span>
                </b-button>
            </div>

            <!-- Action Buttons -->
            <div class="d-flex align-items-center" v-if="items.length > 0 && podeExcluir">
                <b-button 
                    variant="danger" 
                    pill 
                    class="px-4 font-weight-bold shadow-sm" 
                    @click="verificarExclusao()" 
                    :disabled="loading"
                >
                  <i class="fa fa-trash mr-2"></i>
<span class="d-none d-sm-inline">Excluir</span> <span class="d-none d-lg-inline ml-1" style="opacity: 0.7; font-size: 0.9em;">(F8)</span>
                </b-button>
            </div>
        </div>
      </div>

       <!-- Status Strip -->
      <div v-if="items.length > 0" class="mb-3 px-1">
          <b-alert show :variant="podeExcluir ? 'success' : 'danger'" class="mb-0 shadow-sm border-0 d-flex align-items-center p-3 rounded-lg">
              <div class="mr-3 d-flex align-items-center justify-content-center bg-white rounded-circle shadow-sm" style="width:40px; height:40px; flex-shrink:0;">
                  <i :class="podeExcluir ? 'fa fa-check text-success fa-lg' : 'fa fa-ban text-danger fa-lg'"></i>
              </div>
              <div>
                  <h6 class="font-weight-bold mb-0" :class="podeExcluir ? 'text-success' : 'text-danger'">{{ podeExcluir ? 'Disponível para exclusão' : 'Operação Bloqueada' }}</h6>
                  <small :class="podeExcluir ? 'text-secondary' : 'text-danger'" class="opacity-75">{{ podeExcluir ? 'Esta etiqueta pode ser removida do estoque.' : 'A etiqueta não pode ser excluída pois contém restrições ou já foi removida.' }}</small>
              </div>
          </b-alert>
      </div>

      <!-- Results Table -->
       <b-row class="ml-0 mr-0 p-0">
        <b-col sm="12" class="p-0">
          <b-table 
             hover 
             striped 
             :items="items" 
             :fields="fields" 
             :busy="loading"
             responsive="sm" 
             small 
             class="modern-premium-table"
             show-empty
          >
             <template #cell(SITUACAO)="row">
                <span class="badge badge-danger" v-if="String(row.item.SITUACAO) === '0'">Inativo / Excluído</span>
                <span class="badge badge-success" v-else>Ativo</span>
             </template>

             <template #empty>
                <div class="text-center p-5">
                   <div class="mb-3 text-muted opacity-50">
                       <i class="fa fa-search fa-3x"></i>
                   </div>
                   <h6 class="text-muted">Nenhum registro encontrado.</h6>
                   <small class="text-muted">Utilize a pesquisa acima para localizar o histórico da etiqueta.</small>
                </div>
             </template>
             <template #table-busy>
                <div class="text-center text-primary my-5">
                  <b-spinner class="align-middle mb-2"></b-spinner>
                  <div class="font-weight-bold">Buscando informações...</div>
                </div>
             </template>
          </b-table>
        </b-col>
      </b-row>
    </div>

    <!-- Modal Modern Premium -->
    <b-modal ref="modalExclusao" 
             hide-footer 
             hide-header 
             centered
             size="lg"
             content-class="shadow-xl border-0 rounded-lg overflow-hidden" 
             body-class="p-0 bg-white"
             @shown="focarMotivo">
        
        <!-- Header Redondo Premium -->
        <div class="modal-header-premium bg-danger text-white text-center p-5 position-relative">
             <div class="position-absolute" style="top:15px; right:15px;">
                  <button class="btn btn-sm btn-outline-light border-0 rounded-circle" @click="$refs.modalExclusao.hide()">
                      <i class="fa fa-times fa-lg"></i>
                  </button>
             </div>
             <div class="mb-3 animate-bounce">
                  <div class="bg-white rounded-circle d-inline-flex align-items-center justify-content-center shadow-lg text-danger" style="width: 80px; height: 80px;">
                      <i class="fa fa-trash-o fa-3x"></i>
                  </div>
             </div>
             <h4 class="font-weight-bold mb-1" v-if="etiquetaInfo">Etiqueta: {{ etiquetaInfo.CODIGO || codigoPesquisa }}</h4>
             <h4 class="font-weight-bold mb-1" v-else>Etiqueta: {{ codigoPesquisa }}</h4>
             <h5 class="font-weight-normal mb-2 opacity-90" v-if="etiquetaInfo">{{ etiquetaInfo.DESCRICAO }}</h5>
             <p class="mb-0 opacity-75 font-weight-light small">Essa ação removerá o item do estoque físico e sistêmico.</p>
        </div>

        <div v-if="etiquetaInfo" class="p-4 px-md-5">
             <!-- Info Table Clean -->
             <div class="bg-light rounded-lg p-3 mb-4 border border-light shadow-sm">
                 <h6 class="text-uppercase text-muted font-weight-bold small mb-3 letter-spacing-1">Detalhes do Produto</h6>
                 <div class="row">
                      <div class="col-6 col-md-3">
                          <label class="small text-muted mb-0 font-weight-bold">Peso</label>
                          <div class="text-dark">{{ etiquetaInfo.PESO }}</div>
                      </div>
                      <div class="col-6 col-md-3">
                          <label class="small text-muted mb-0 font-weight-bold">Peças</label>
                          <div class="text-dark">{{ etiquetaInfo.PECAS_CAIXA }}</div>
                      </div>
                       <div class="col-6 col-md-3">
                          <label class="small text-muted mb-0 font-weight-bold">Caixa</label>
                          <div class="text-dark">#{{ etiquetaInfo.NUMERO_CAIXA }}</div>
                      </div>
                       <div class="col-6 col-md-3">
                          <label class="small text-muted mb-0 font-weight-bold">Cód. Barras</label>
                          <div class="text-primary small text-break">{{ etiquetaInfo.CODIGO_BARRAS }}</div>
                      </div>
                 </div>
             </div>
             
             <!-- Form Compact -->
             <div class="form-group mb-3">
                 <label class="font-weight-bold text-dark small text-uppercase">Motivo da Exclusão <span class="text-danger">*</span></label>
                 <b-form-select ref="inputMotivo" v-model="exclusao.opMotivo" :options="motivosOptions" class="custom-select-lg shadow-sm bg-white"></b-form-select>
             </div>

             <div class="form-group mb-4">
                 <label class="font-weight-bold text-dark small text-uppercase">Observações (Opcional)</label>
                 <b-form-textarea 
                    v-model="exclusao.observacao" 
                    rows="2" 
                    placeholder="Adicione detalhes..." 
                    class="shadow-sm bg-white"
                 ></b-form-textarea>
             </div>
             
             <!-- Actions Centered -->
             <div class="row">
                 <div class="col-6">
                     <b-button variant="light" block class="py-3 font-weight-bold text-muted border" @click="$refs.modalExclusao.hide()">
                        Cancelar
                     </b-button>
                 </div>
                 <div class="col-6">
                     <b-button variant="danger" block class="py-3 font-weight-bold shadow-sm" @click="confirmarExclusao()" :disabled="!exclusao.opMotivo">
                         Confirmar
                     </b-button>
                 </div>
             </div>
        </div>
        <div v-else class="text-center p-5">
            <b-spinner variant="danger" type="grow" label="Carregando..."></b-spinner>
        </div>
    </b-modal>
  </div>
</template>

<script>
import Tools from '@/tools/tools'

export default {
  name: 'MovimentoEtiqueta',
  data() {
    return {
      items: [],
      loading: false,
      tipoPesquisa: 'C',
      codigoPesquisa: '',
      opcoesPesquisa: [
          { text: 'Caixa', value: 'C' },
          { text: 'Barra', value: 'B' }
      ],
      etiquetaInfo: null,
      exclusao: {
          opMotivo: null,
          observacao: ''
      },
      motivosOptions: [
          { value: null, text: 'Selecione um motivo...', disabled: true },
          { value: '1', text: 'TROCA DE TAMPA' },
          { value: '2', text: 'DISCARTE' },
          { value: '3', text: 'VENCIDO' },
          { value: '4', text: 'INAPROPRIADO PARA CONSUMO' },
          { value: '5', text: 'OUTROS' },
      ],
      fields: [
          { key: 'ID', label: 'ID', sortable: true, class: 'text-center' },
          { key: 'CODIGO', label: 'Código', sortable: true },
          { key: 'DESCRICAO', label: 'Produto', sortable: true },
          { key: 'CODIGO_BARRAS', label: 'Cód. Barras', sortable: true },
          { key: 'NUMERO_CAIXA', label: 'Nº Caixa', sortable: true, class: 'text-center' },
          { key: 'PESO', label: 'Peso', sortable: true, class: 'text-right font-weight-bold' },
          { key: 'PECAS_CAIXA', label: 'Peças', sortable: true, class: 'text-center' },
          { key: 'USUARIO_CADASTRO', label: 'Usuário', sortable: true },
          { key: 'DATA_MOVIMENTO', label: 'Data', sortable: true },
          { key: 'FORNECEDOR', label: 'Fornecedor', sortable: true },
          { key: 'HISTORICO', label: 'Histórico', sortable: true },
          { key: 'SITUACAO', label: 'Status', sortable: true, class: 'text-center' }
      ]
    }
  },
  watch: {
    codigoPesquisa(val) {
      if (!val) {
        this.items = [];
      } else {
        // Limpa items ao digitar para não deixar resultados de pesquisa antiga enquanto digita
        this.items = [];
      }
    }
  },
  mounted() {
    window.addEventListener('keydown', this.handleKeydown)
    this.focusAndSelectSearch()
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.handleKeydown)
  },
  computed: {
      podeExcluir() {
          if (!this.items || this.items.length === 0) return false;
          // Verifica se NENHUM registro tem situação '0' (excluído)
          // Se algum tiver situação '0', retorna false.
          const temExcluido = this.items.some(item => String(item.SITUACAO) === '0');
          return !temExcluido;
      }
  },
  methods: {
    handleKeydown(e) {
        if (e.key === 'F8') {
            e.preventDefault()
            // Sames logic as button click disabled state
            if (this.podeExcluir && !this.loading && this.items.length > 0) {
                this.verificarExclusao()
            }
        }
    },
    async pesquisar() {
        if (!this.codigoPesquisa) {
            Tools.exibirMensagem(this.$store, 'Atenção', 'warning', 'Informe o código para pesquisar');
            return;
        }

        this.loading = true;
        this.items = [];
        
        try {
            // GET /api/protected/estoqueetiqueta/getMovimentacaoEtiqueta/:tipo/:codigo
            const url = `/api/protected/estoqueetiqueta/getMovimentacaoEtiqueta/${this.tipoPesquisa}/${this.codigoPesquisa}`;
            const response = await this.$http.get(url);
            
            if (response.data) {
                this.items = response.data;
                if(this.items.length === 0) {
                     Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Nenhum histórico encontrado para este código.');
                }
            }
        } catch (error) {
            console.error(error);
            Tools.exibirMensagem(this.$store, 'Erro', 'danger', error);
        } finally {
            this.loading = false;
            this.focusAndSelectSearch();
        }
    },
    async verificarExclusao() {
        if (!this.items.length) return;
        
        // Pega o ID da etiqueta. 
        const etiquetaRow = this.items[0];
        const id = etiquetaRow.ESTOQUE_ETIQUETA_ID || etiquetaRow.ID;

        this.etiquetaInfo = null;
        this.exclusao.opMotivo = null;
        this.exclusao.observacao = '';
        this.$refs.modalExclusao.show();
        
        try {
             // Simulação leve de delay pra dar feedback visual caso API seja instantânea demais (opcional)
             // await new Promise(r => setTimeout(r, 300));

             const response = await this.$http.get(`/api/protected/estoqueetiqueta/getById/${id}`);
             this.etiquetaInfo = response.data;
             if (Array.isArray(response.data)) {
                 this.etiquetaInfo = response.data[0];
             }
        } catch (error) {
            console.error(error);
            Tools.exibirMensagem(this.$store, 'Erro', 'danger', 'Não foi possível carregar os dados da etiqueta.');
            this.$refs.modalExclusao.hide();
        }
    },
    async confirmarExclusao() {
        if (!this.exclusao.opMotivo) {
            Tools.exibirMensagem(this.$store, 'Atenção', 'warning', 'Selecione um motivo.');
            return;
        }
        
        const login = window.localStorage.getItem('login');
        if (!login) {
             Tools.exibirMensagem(this.$store, 'Erro', 'danger', 'Usuário não identificado.');
             return;
        }

        const id = this.etiquetaInfo.ID || this.etiquetaInfo.ESTOQUE_ETIQUETA_ID; 

        const payload = {
            login: login,
            estoqueEtiquetaId: id,
            opMotivo: this.exclusao.opMotivo
        };

        try {
            await this.$http.post(`/api/protected/estoqueetiqueta/removerEtiquetaEstoque`, payload);
            Tools.exibirMensagem(this.$store, 'Sucesso', 'success', 'Etiqueta removida com sucesso.');
            this.$refs.modalExclusao.hide();
            this.pesquisar(); // Refresh list
        } catch (error) {
             console.error(error);
             Tools.exibirMensagem(this.$store, 'Erro', 'danger', error);
        }
    },
    focarMotivo() {
        // Tenta focar o elemento nativo do select
        this.$nextTick(() => {
            if (this.$refs.inputMotivo && this.$refs.inputMotivo.$el) {
                 this.$refs.inputMotivo.$el.focus();
            } else if (this.$refs.inputMotivo) {
                 this.$refs.inputMotivo.focus();
            }
        });
    },
    focusAndSelectSearch() {
        this.$nextTick(() => {
            if (this.$refs.searchInput && this.$refs.searchInput.$el) {
                const input = this.$refs.searchInput.$el;
                input.focus();
                input.select();
            }
        });
    }
  }
}
</script>

<style scoped>
/* Copiando estilos premium do PedidoVendaListagemWeb */
.list-header-premium {
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 2px 12px rgba(0,0,0,0.05);
}

.header-icon-wrapper {
    width: 48px;
    height: 48px;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    box-shadow: 0 4px 10px rgba(0,0,0,0.1);
}

.modern-premium-table {
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 2px 8px rgba(0,0,0,0.03);
    background: white;
}

/* Responsividade da barra de busca */
@media (max-width: 576px) {
    .search-pill-responsive {
        flex-direction: column;
        width: 100%;
        border-radius: 12px !important;
        align-items: stretch !important;
    }
    .input-search-responsive {
        width: 100% !important;
    }
    .btn-filtrar-responsive {
        width: 100%;
        margin-top: 5px;
    }
    .btn-adicionar-responsive span {
        display: none;
    }
}

.bg-danger-light {
    background-color: rgba(220, 53, 69, 0.1);
}

/* Scroll suavizado no modal se conteudo for grande */
.modal-body {
    max-height: 80vh;
    overflow-y: auto;
}
</style>



// WEBPACK FOOTER //
// src/views/estoque/MovimentoEtiqueta.vue